import { createFileRoute } from '@tanstack/react-router';
import { DesktopItems } from '@/features/warehouse/DesktopArticoli';

/** L'anagrafica articoli: senza questa il magazzino non si può nemmeno caricare. */
export const Route = createFileRoute('/_app/warehouse/items')({ component: DesktopItems });
